/* eslint-disable no-underscore-dangle */
import gql from "graphql-tag.macro";
import axios from "axios";
import { deleteProject } from "../projectList/projectList.api";

const v3CreateProjectMutation = gql`
  mutation createProject(
    $parentId: ObjectID!
    $legacyId: ID
    $projectName: String!
  ) {
    createProjectInInstance(
      parentId: $parentId
      input: {
        name: $projectName
        legacyId: $legacyId
        description: $projectName
        disabled: false
      }
    ) {
      _id
      name
      description
    }
  }
`;

const loadCurrentUserQuery = gql`
  query me {
    me(forceRefresh: true) {
      _id
      username
      firstname
      lastname
      email
    }
  }
`;

const loadGroupsByProjectQuery = gql`
  query loadGroupsByProject($projectId: ID!) {
    groupsByProject(projectId: $projectId) {
      id
      name
      path
    }
  }
`;

const rolloverUsersToProjectMutation = gql`
  mutation rolloverUsersToProject(
    $specialCase: [UserRolloverSpecialCase!]!
    $toProject: ID!
  ) {
    rolloverUsersInProject(
      clients: []
      fromProject: ""
      toProject: $toProject
      specialCase: $specialCase
    ) {
      client
      email
      status
      remarks
      userId
      instanceId
      fromProjectId
      toProjectId
    }
  }
`;

export const rolloverUsersToProject = async (
  { toProject, users },
  { client }
) => {
  const _client =
    window.location.hostname.indexOf("127.0.0.1") > -1
      ? "127.0.0.1:5003"
      : window.location.hostname;
  const { data: { rolloverUsersToProject: data } = {} } = await client.mutate({
    mutation: rolloverUsersToProjectMutation,
    variables: {
      toProject,
      specialCase: [{ client: _client, users }],
    },
  });
  return data;
};

export const v2CreateProject = async (
  { projectName, projectOrganisation },
  {}
) => {
  if (window?.APPVERSION?.directory) {
    try {
      const projectsResponse = await axios.get(
        `${window.location.origin}/api/getBackupProjects`, {
          params: {
            sessionID: window.app.Duchess.getCookie("SESSION_ID"),
            v3ProjectId: window.app.Duchess.currentProject._id,
          },
        }
      );

      const currentProjects =
        projectsResponse?.data?.data?.currentProjects || [];
      if (currentProjects.some((project) => project.title === projectName))
        throw new Error("Project already exists");

      const { success, ID, message } = await window.app.Duchess.createProject(
        projectName,
        projectOrganisation
      );
      if (success) {
        return {
          projectId: ID,
        };
      }
      throw new Error(message);
    } catch (error) {
      if (axios.isAxiosError(error)) {
          const data = error.response?.data;
          const backendMessage = data?.message || JSON.stringify(data) || error.message;

          throw new Error(backendMessage);
        }

      throw new Error(error?.message);
    }
  }
};

export const rollback = async ({ legacyId }) => {
  await deleteProject({ id: legacyId });
};

export const loadCurrentUser = async ({ client }) => {
  const {
    data: { me: data },
  } = await client.query({
    query: loadCurrentUserQuery,
    variables: {},
    fetchPolicy: "no-cache",
  });
  return data;
};

export const loadGroupsByProject = async ({ projectId }, { client }) => {
  const {
    data: { groupsByProject: data },
  } = await client.query({
    query: loadGroupsByProjectQuery,
    variables: {
      projectId,
    },
    fetchPolicy: "no-cache",
  });
  return data || [];
};

export const v3CreateProject = async (
  { legacyId, parentId, projectName },
  { client }
) => {
  const { data: { createProjectInInstance: data } = {} } = await client.mutate({
    mutation: v3CreateProjectMutation,
    variables: { legacyId, parentId, projectName },
  });
  return data;
};
